import script from "./AssessmentDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentDetail.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentDetail.vue?vue&type=style&index=0&id=88cde0fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88cde0fe"]])

export default __exports__